import { redirect } from 'react-router-dom';
import {
  getReturnUrlFromRequestLoader,
  getPostFlowUrl,
} from 'utils/common/route';
import { getWalmartAuthorizationParams } from 'hooks/router';
import { getParamsFromStoreRedux } from 'store/utils';

export const checkAuthorizationLoader = async ({ request }) => {
  const returnUrl = getReturnUrlFromRequestLoader(request) || '/';
  const { dispatch } = getParamsFromStoreRedux();

  const { isWalmartAuthorize, walmartSearchQuery } =
    getWalmartAuthorizationParams(request);

  // If not Walmart authorization, redirect to next step immediately
  if (!isWalmartAuthorize) {
    const redirectUrl = getPostFlowUrl({
      type: 'check-authorization',
      returnUrl,
      dispatch,
    });

    throw redirect(redirectUrl);
  }

  return {
    isWalmartAuthorize,
    walmartSearchQuery,
    returnUrl,
    timestamp: new Date(),
  };
};
